var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsStarOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79381 13.6275L9.49992 13.414L9.20604 13.6275L4.55818 17.0042L4.36589 16.8647L4.36901 16.853L6.14046 11.4005L6.25269 11.055L5.95885 10.8415L1.30961 7.46299L1.3828 7.23751H7.12992H7.49318L7.60545 6.89203L9.38118 1.42751H9.61867L11.3944 6.89203L11.5067 7.23751H11.8699H17.617L17.6902 7.46299L13.041 10.8415L12.7472 11.055L12.8594 11.4005L14.6342 16.864L14.4414 17.004L9.79381 13.6275Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsStarOutline);
export default __webpack_public_path__ + "static/media/icons-star-outline.f5f01298575bc9e90646b67570be9c88.svg";
export { ForwardRef as ReactComponent };